<div
  class="relative flex h-full flex-col rounded-2xl"
  [ngClass]="{
    'cursor-pointer': clickable(),
    'pt-8': mostPopular(),
    'outline outline-3 outline-brand-subtle': mostPopular() && selected(),
  }"
  [sbTooltip]="disabled() ? disabledTooltip() : undefined"
  [sbTooltipPlacement]="'right'"
  [sbTooltipDisabled]="!disabled()"
>
  @if (mostPopular()) {
    <div
      class="absolute inset-x-0 top-0 flex h-12 items-start justify-center gap-2 rounded-2xl rounded-b-none pt-1.5"
      [ngClass]="{
        'bg-brand text-brand-inverted': selected(),
        'bg-primary-hover text-inverted': !selected(),
      }"
    >
      <sb-icon [name]="'stars'" [size]="'lg'" class="mt-0.5" />
      <span class="text-base font-semibold">{{ 'Most popular' | translate }}</span>
    </div>
  }

  <div
    class="relative flex h-full gap-4 rounded-2xl border-2 border-solid bg-surface-page p-6"
    [ngClass]="{
      'border-brand': selected(),
      'border-default': !selected(),
      'hover:border-brand hover:shadow-lg': clickable(),
      'outline outline-3 outline-brand-subtle': !mostPopular() && selected(),
      'mt-8': !mostPopular() && isVertical(),
      'flex-col': isVertical(),
      'flex-row-reverse': !isVertical(),
    }"
  >
    <div class="flex items-start gap-md">
      <div class="flex grow flex-wrap items-start gap-md">
        @if (isCurrent()) {
          <sb-badge color="brand">{{ inTrial() ? ('Your Trial' | translate) : ('Current plan' | translate) }}</sb-badge>
        }
        @if (disabled()) {
          <sb-badge color="grey">{{ 'Plan not available' | translate }}</sb-badge>
        }
        @if (showTrialBadge()) {
          <sb-badge color="grey">{{ 'Free 14-day trial' | translate }}</sb-badge>
        }
      </div>

      <div
        class="size-5 shrink-0 rounded-full border-solid"
        [ngClass]="{
          'border-2 border-default': !selected(),
          'border-6 border-brand': selected(),
          'opacity-50': disabled(),
        }"
      ></div>
    </div>

    <div
      class="flex grow flex-col items-start overflow-hidden"
      [ngClass]="{
        'gap-4': isVertical(),
        'gap-2': !isVertical(),
      }"
    >
      <div
        class="max-w-full"
        [ngClass]="{
          'opacity-50': disabled(),
        }"
      >
        <span
          class="block font-bold text-default"
          [ngClass]="{
            'text-3xl': isVertical(),
            'text-2xl': !isVertical(),
          }"
          >{{ name() }}</span
        >
        @if (tagline() && isVertical()) {
          <span class="block text-base font-normal text-support">{{ tagline() }}</span>
        }
      </div>
      @if (useNewPricingStructure() && isVertical()) {
        <div
          class="flex flex-col gap-1"
          [ngClass]="{
            'opacity-50': disabled(),
          }"
        >
          <span class="text-4xl font-bold text-default">{{ displayPrice() }}</span>
          <span class="text-sm font-medium text-support">{{
            'Includes your first [minAmount] employees' | translate: { minAmount: minOrderQuantity() }
          }}</span>
          @if (additionalEmployeeCost(); as employeeCost) {
            <span class="text-sm font-normal text-subtle">
              {{ 'Add unlimited employees for [cost] per employee' | translate: { cost: employeeCost.cost } }}
            </span>
            <span class="text-sm font-normal text-subtle">{{ employeeCost.billingPeriod }}</span>
          }
        </div>
      }
      @if (!useNewPricingStructure()) {
        <div
          class="text-sm font-medium text-subtle"
          [ngClass]="{
            'opacity-50': disabled(),
            'flex flex-col gap-1': isVertical(),
          }"
        >
          <span
            class=""
            [ngClass]="{
              'text-4xl font-bold text-default': isVertical(),
            }"
            >{{ displayPrice() }}
          </span>
          <span [ngClass]="{ 'mb-5': isFree() }">{{
            isFree() ? ('no payment details required' | translate) : ('per active employee/month' | translate)
          }}</span>
          @if (!isFree() && isVertical()) {
            <span>{{ 'starting at [minAmount] employees' | translate: { minAmount: minOrderQuantity() } }}</span>
          }
        </div>
      }

      @if (features()?.length && isVertical()) {
        <hr sbDivider />

        <div
          class="flex flex-col gap-3.5"
          [ngClass]="{
            'opacity-50': disabled(),
          }"
        >
          <span class="text-base font-bold text-default">{{ featureTitle() }}</span>
          @for (feature of features(); track feature) {
            <div class="flex items-center justify-start gap-2 text-base font-medium text-support">
              <sb-icon
                class="shrink-0"
                [ngClass]="{
                  'text-success': brandColor() === 'green',
                  'text-brand': brandColor() === 'primary',
                }"
                [name]="'check'"
                [size]="'sm'"
              />
              {{ feature | translate: featureParams() }}
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
